module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAASCAYAAACq26WdAAAAkElEQVRIS+2VsRHCQAwE774CCnBGAwSUQOBuaOfvG8EzboAZE1CEc1zBi/mEIXL0UmQVcHs6SSPmnBeSVziXmb0o6QFgdGY1+YkBkB/igHVJOzZGSWeSQxfrOyJmtrbV/wA4ecMAbCyl3GutF29YSukdOzPvjv71j866pB0bo6QZwK2L9f2jntpRLwAinufzC13PJxuGmPj7AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/menu.png
// module id = FgJe
// module chunks = 0